"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ArrowBack = _interopRequireDefault(require("@tvg/fuse-icons/lib/ArrowBack"));
var _Close = _interopRequireDefault(require("@tvg/fuse-icons/lib/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledModalHeader = require("./styled-modal-header");
var _excluded = ["backCallback", "closeCallback", "hasBackButton", "hasClose", "hasDepth", "headerIcon", "headingId", "srLabelBackButton", "srLabelCloseButton", "title"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  title: _propTypes["default"].string.isRequired,
  backCallback: _propTypes["default"].func,
  closeCallback: _propTypes["default"].func,
  hasBackButton: _propTypes["default"].bool,
  hasClose: _propTypes["default"].bool,
  hasDepth: _propTypes["default"].bool,
  headerIcon: _propTypes["default"].element,
  headingId: _propTypes["default"].string,
  srLabelBackButton: _propTypes["default"].string,
  srLabelCloseButton: _propTypes["default"].string
};
var defaultProps = {
  backCallback: function backCallback() {},
  closeCallback: function closeCallback() {},
  hasBackButton: false,
  hasClose: true,
  hasDepth: false,
  headerIcon: undefined,
  headingId: undefined,
  srLabelBackButton: undefined,
  srLabelCloseButton: undefined
};
var ModalHeader = forwardRef(function (_ref, ref) {
  var backCallback = _ref.backCallback,
    closeCallback = _ref.closeCallback,
    hasBackButton = _ref.hasBackButton,
    hasClose = _ref.hasClose,
    hasDepth = _ref.hasDepth,
    headerIcon = _ref.headerIcon,
    headingId = _ref.headingId,
    srLabelBackButton = _ref.srLabelBackButton,
    srLabelCloseButton = _ref.srLabelCloseButton,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledModalHeader.StyledModalHeader, _extends({
    hasDepth: hasDepth,
    ref: ref
  }, rest), hasBackButton && /*#__PURE__*/_react["default"].createElement(_styledModalHeader.StyledModalBackButton, {
    callback: backCallback,
    icon: /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null),
    ref: ref,
    srLabel: "".concat(srLabelBackButton, " dialog")
  }), headerIcon && /*#__PURE__*/_react["default"].createElement(_styledModalHeader.StyledModalHeadingIcon, {
    color: "var(--color-brand-mid)",
    icon: headerIcon,
    responsiveSize: "small"
  }), /*#__PURE__*/_react["default"].createElement(_styledModalHeader.StyledModalHeading, {
    hasBackButton: hasBackButton,
    headerIcon: headerIcon,
    id: headingId || "fuse-modal-heading",
    size: "3",
    type: "heading",
    tabIndex: 0
  }, title), hasClose && /*#__PURE__*/_react["default"].createElement(_styledModalHeader.StyledModalCloseButton, {
    callback: closeCallback,
    icon: /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    srLabel: "".concat(srLabelCloseButton, " dialog")
  }));
});
ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
var _default = exports["default"] = ModalHeader;